/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { SystemManagerExportReturnCodes } from '../../../../../../shared/ui/src/lib/enums/system-manager-export-return-codes';
import { Observable } from 'rxjs';

export interface IImportSystemsFacade {
  closeWindow(): void;
  windowResize(height: number, width: number): void;
  getAllImportSystems(filePath: string): Observable<string[]>;
  getSystemsFromConfiguration(): Observable<string[]>;
  getLocalStorageForImportSystemsFile(): string;
  importSystemsLogic(
    importSystems: { [key: string]: string },
    filePath: string
  ): Observable<SystemManagerExportReturnCodes>;
}

export const IMPORT_SYSTEMS_FACADE_TOKEN = new InjectionToken<IImportSystemsFacade>('IMPORT_SYSTEMS_FACADE_TOKEN');
